import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function WhoIsNotForSection() {
  const notForItems = ['Personas que buscan una pérdida de peso milagrosa de 10 kilos en tres días.', 'Quienes no están dispuestos a seguir un plan sencillo por solo 72 horas.', 'Personas que prefieren seguir gastando en pastillas y fajas en lugar de sanar su digestión.'];
  return <section className="w-full py-16 md:py-24" style={{
    backgroundColor: '#FAFAF7'
  }} data-id="element-230">
      <div className="max-w-4xl mx-auto px-4" data-id="element-231">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-232">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-12" style={{
          color: '#1A1A1A'
        }} data-id="element-233">
            ¿Para quién NO es?
          </h2>

          <div className="bg-[#FFF5F5] rounded-3xl p-6 md:p-10 border border-red-100" data-id="element-234">
            <ul className="space-y-5" data-id="element-235">
              {notForItems.map((item, index) => <motion.li key={index} className="flex items-start gap-4" initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} data-id="element-236">
                  <div className="w-6 h-6 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-237">
                    <XIcon className="w-4 h-4 text-red-400" data-id="element-238" />
                  </div>
                  <span className="text-base md:text-lg" style={{
                color: '#4A4A4A'
              }} data-id="element-239">
                    {item}
                  </span>
                </motion.li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}